/**
 * Menu component
 * Menu icon that displays a drop down menu on click
 */
import React from "react"
import Icon from "components/Icon"
import { NavLink } from "react-router-dom"
import onClickOutside from "react-onclickoutside"
import theme from "styles/theme-main"
import { Wrapper, MenuIcon, MenuItem, MenuWrapper } from "styles/Menu"
import { getCurrentSize, isATSOrganization } from "utils/utils"
import { isProfileMode } from "utils/productUtils"
import { profileUrl } from "utils/config"
import styled from "styled-components"
import UserService from "services/user"

export const Link = styled.div`
  text-transform: uppercase;
  letter-spacing: 3px;
  font-size: 14px;
  color: ${props => props.theme.colors.textSecondaryDark};
  text-decoration: none;
  display: block;
  padding: 15px 0;
  margin-bottom: 10px;

  &:hover {
    font-weight: bold;
    color: ${props => props.theme.colors.light} !important;
  }
`

export class Menu extends React.Component {
  state = {
    isOpen: null,
  }

  toggleMenu = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    })
  }

  closeMenu = () => {
    this.setState({
      isOpen: false,
    })
  }

  handleClickOutside() {
    const currentSize = getCurrentSize()
    if (currentSize === "lg" || currentSize === "xl") {
      this.setState({
        isOpen: false,
      })
    }
  }

  goToApplications = () => {
    UserService.generateToken().then(res => {
      window.open(profileUrl + `/magic-password/?token=${res.data}`)
    })
  }

  render() {
    const { isOpen } = this.state
    const { bgcolor, organization } = this.props

    const iconColor =
      bgcolor === "#ffffff"
        ? theme.colors.textSecondaryDark
        : theme.colors.light

    return (
      <React.Fragment>
        <Wrapper isOpen={isOpen}>
          <MenuIcon
            tabIndex={0}
            onClick={this.toggleMenu}
            onKeyPress={this.toggleMenu}
            isOpen={isOpen}
            color={iconColor}
          >
            <Icon variant={isOpen ? "cross_sml" : "menu"} />
          </MenuIcon>
        </Wrapper>
        <MenuWrapper isOpen={isOpen}>
          <MenuItem onClick={this.closeMenu}>
            {isProfileMode() && (
              <NavLink
                to={"/applications"}
                activeStyle={{
                  color: theme.colors.primaryDark,
                  fontWeight: "bold",
                }}
              >
                Applications
              </NavLink>
            )}
            {isATSOrganization(organization) && (
              <Link onClick={this.goToApplications}>Applications</Link>
            )}
          </MenuItem>
        </MenuWrapper>
      </React.Fragment>
    )
  }
}

export default onClickOutside(Menu)
